import Immutable from 'seamless-immutable';

import { acls } from '~/api';

const initialState = Immutable({
  scopes: [],
  loading: true,
  error: null
});

const areScopesEqual = (current, next) =>
  current.length === next.length &&
  JSON.stringify([...current].sort()) === JSON.stringify([...next].sort());

const aclsModel = {
  name: 'acls',
  state: initialState,
  reducers: {
    setScopes(state, scopes) {
      const next = scopes || [];
      if (areScopesEqual(state.scopes || [], next)) {
        return state;
      }
      return state.merge({ scopes: next });
    },
    loading(state, loading) {
      return state.merge({ loading });
    },
    actionNotPermitted(state) {
      return state;
    }
  },
  effects: dispatch => ({
    async fetch(payload, rootState) {
      const silent = payload?.silent === true;
      if (!silent) {
        dispatch.acls.loading(true);
      }
      try {
        const { realm } = rootState.application.realm;
        const { scopes } = await acls.fetch({ realm });
        dispatch.acls.setScopes(scopes);
        if (!silent) {
          dispatch.acls.loading(false);
        }
      } catch (error) {
        if (!silent) {
          dispatch.acls.loading(false);
        }
      }
    }
  }),
  logics: [
    {
      type: 'application/findRealms',
      latest: true,
      process(context, dispatch, done) {
        dispatch.acls.fetch();
        done();
      }
    },
    {
      type: '*',
      latest: true,
      validate({ getState, action }, allow, reject) {
        if (action.meta && action.meta.acls) {
          const defaultAcls = ['GROUP:ADMIN'];
          const roles = [].concat(action?.meta?.acls, defaultAcls);
          const scopes = getState().acls?.scopes;
          const isAuthorized = scopes.some(scope => roles.includes(scope));
          if (isAuthorized) {
            allow(action);
          } else {
            reject({
              type: 'acls/actionNotPermitted',
              payload: {},
              error: true
            });
          }
        } else {
          allow(action);
        }
      }
    }
  ]
};

export default aclsModel;
